module.exports = new __parcel__URL__("product-requirements-dark.2b46bcb3.png").toString();